import Api from "..";
import PrivateUser from "../../dtos/user";
import { UserLoginInput, UserLoginResponse } from "../../dtos/user/auth";
import { UserOtpResponse } from "../../dtos/user/otp";
import transform from "../../service/transform";

export default class UserAuthApi extends Api {
  constructor() {
    super("user/auth");
  }

  public async get(): Promise<PrivateUser> {
    return await transform(PrivateUser)((await super.get()).data);
  }

  public async post(data: UserLoginInput): Promise<UserLoginResponse> {
    return await transform(UserLoginResponse)((await super.post(data)).data);
  }

  public async put(id: "", data: UserLoginInput): Promise<UserOtpResponse> {
    return await transform(UserOtpResponse)((await super.put("0", data)).data);
  }

  public async delete(): Promise<void> {
    await super.delete("0");
  }
}
